// client/src/services/api.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

// Admin API instance (for admin dashboard)
const api = axios.create({
    baseURL: API_URL,
    timeout: 10000,
});

// Request interceptor for admin auth token
api.interceptors.request.use((config) => {
    // Lightweight JS verification header for server-side human gate
    config.headers["X-JS-Verified"] = "1";
    const token = localStorage.getItem("adminToken");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem("adminToken");
            window.location.href = "/admin/login";
        }
        return Promise.reject(error);
    }
);

// User API instance (for user-facing features like ratings, favorites)
export const userApi = axios.create({
    baseURL: API_URL,
    timeout: 10000,
});

// Request interceptor for user auth token
userApi.interceptors.request.use((config) => {
    // Lightweight JS verification header for server-side human gate
    config.headers["X-JS-Verified"] = "1";
    // Check both localStorage and sessionStorage for user token
    const token = localStorage.getItem("telo_user_access_token") ||
                  sessionStorage.getItem("telo_user_access_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Response interceptor for user API
userApi.interceptors.response.use(
    (response) => response,
    (error) => {
        // Don't redirect on 401 for user API, let components handle it
        return Promise.reject(error);
    }
);

export default api;
